import React, {useContext, useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config';
import axios from 'axios';
import DialogContentText from '@mui/material/DialogContentText';
import useNotification from '../../../hooks/useNotification';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function DeleteBannersDialog(props) {
    const auth = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const { notificationSuccess, notificationError } = useNotification();

    const deleteBanner = async() => {
        try {
            setLoading(true);
        
            if(!props.lastCellData.idEntita.S)return;

            const essentialData = {
                idEntita: props.lastCellData.idEntita.S,
                city: props.lastCellData.city.S,
            }

            const axiosParams = {
                url: '/delete-banner',
                method: 'post',
                baseURL: config.API_URL,
                headers: {
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: essentialData
            };

            await axios(axiosParams);
            notificationSuccess('Banner Eliminato');

            props.handleCloseDeleteBannersDialog();
            await props.getBanners();
            
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    return (
        <Dialog className="" open={props.openDeleteBannersDialog} onClose={props.handleCloseDeleteBannersDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Elimina Banner - {props?.lastCellData?.descrizione.S}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Vuoi eliminare il banner "{props?.lastCellData?.descrizione.S || ''}"?
                </DialogContentText>
                <DialogContentText>L'azione è irreversibile.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={deleteBanner}>
                    Elimina
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseDeleteBannersDialog}>
                    Annulla
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DeleteBannersDialog